import { SIZE_SCALE } from '@/components/design-system/tokens';

interface KakaoIconProps {
  className?: string | undefined;
}

/**
 * Kakao icon component - resembles the official Kakao logo (speech bubble)
 */
export const KakaoIcon = ({ className = SIZE_SCALE.iconSm }: KakaoIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 3C6.477 3 2 6.582 2 11c0 2.838 1.89 5.325 4.717 6.72-.196.715-.637 2.334-.734 2.72-.117.468.171.461.361.335.148-.099 2.416-1.61 3.343-2.232.43.058.872.089 1.313.089 5.523 0 10-3.582 10-8S17.523 3 12 3z" />
    </svg>
  );
};

export default KakaoIcon;
